import {TranslateService} from '@ngx-translate/core';

export const enum AppointmentType {
  DoctorVisit = 'DoctorVisit',
  LabVisit = 'LabVisit',
  Chemotherapy = 'Chemotherapy',
  Radiotherapy = 'Radiotherapy',
  Surgery = 'Surgery',
  Oral= 'Oral',
  Integral = 'Integral',
  Nuclear = 'Nuclear',
}

export const ApptTypeMap = (translate: TranslateService) => {
  return {
    [AppointmentType.DoctorVisit]: {
      label: translate.instant('doctorVisitTitle'),
      key: AppointmentType.DoctorVisit,
      url: './assets/doc-visit.svg',
    },
    [AppointmentType.LabVisit]: {
      label: translate.instant('labVisitTitle'),
      key: AppointmentType.LabVisit,
      url: './assets/lab-visit.svg',
    },
    [AppointmentType.Chemotherapy]: {
      label: translate.instant('chemotherapyTitle'),
      key: AppointmentType.Chemotherapy,
      url: './assets/cheomotherapy.svg',
    },
    [AppointmentType.Radiotherapy]: {
      label: translate.instant('radiotherapyTitle'),
      key: AppointmentType.Radiotherapy,
      url: './assets/radiotherapy.svg',
    },
    [AppointmentType.Surgery]: {
      label: translate.instant('surgeryTitle'),
      key: AppointmentType.Surgery,
      url: './assets/surgery.svg',
    },
    [AppointmentType.Oral]: {
      label: translate.instant('getOralMedicineTitle'),
      key: AppointmentType.Oral,
      url: './assets/surgery.svg',
    }, [AppointmentType.Integral]: {
      label: translate.instant('Integral'),
      key: AppointmentType.Integral,
      url: './assets/surgery.svg',
    },
    [AppointmentType.Nuclear]: {
      label: translate.instant('Nuclear'),
      key: AppointmentType.Nuclear,
      url: './assets/surgery.svg',
    },
  };
};
